import { requestFromServer } from "./api-client";

const Plants = {
  /**
   * In case of no ID is given it will return a list of all plants
   * @param {*} id
   * @returns Array of plants
   */
  listByBranch: async (id) => {
    if (id) {
      return requestFromServer(`v1/Plants/list/${id}`);
    }
    return requestFromServer('v1/Plants/list');
  },
  getAllPlants: async () => {
    return requestFromServer('v1/Plants/list');
  },
  listAvailableByBranchAndProduct: async (idProduct, idBranch, idLoadType) => {
    return requestFromServer(
      `v1/Plants/listAvailableToScheduling/${idBranch}/${idProduct}/${idLoadType}`
    );
  },
  add: async (plant) => {
    return requestFromServer(`v1/Plants/add`, "POST", plant);
  },
  update: async (plant) => {
    return requestFromServer(`v1/Plants/update/${plant.id}`, "PUT", plant);
  },
  delete: async (id) => {
    return requestFromServer(`v1/Plants/delete/${id}`, "DELETE");
  },
  findByDocumentNumber: async (idLoadType, documentNumber) => {
    return requestFromServer(
      `v1/Plants/findByDocumentNumber?loadTypeId=${idLoadType}&documentNumber=${documentNumber}`
    );
  },
};

export default Plants;
